import { Injectable, Output, EventEmitter, Input } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class CronometrotiempoService {
  @Input() disparadorCronometro: EventEmitter<any> = new EventEmitter();
  

constructor() { }

}


